import { Fragment, useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormConsulate, { ConsulateForm } from 'system/geographic/components/consulate/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonConsulateCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { Consulate } from 'shell/models/consulate';
import TerritoryAutoCompleteTable from 'system/geographic/components/consulate/form/territory';

const ConsulateDetailPage = (): React.ReactElement => {
  const params = useParams();

  const {
    get: getConsolate,
    data,
    error,
    loading,
  } = useHttpFetch<HttpResponse<Consulate>>(
    `${__MUNICIPALITY_API_URL__}/geo/consolato/${params.id}`
  );

  useEffect(() => {
    getConsolate();
  }, []);

  const consulate: ConsulateForm = useMemo(() => {
    const consulatePayload = data?.payload;
    if (!consulatePayload || !!error) {
      return {};
    }
    return {
      code: consulatePayload.key.codice,
      name: consulatePayload.nome,
      address: consulatePayload.indirizzo,
      category: consulatePayload.categoria,
      municipality:
        consulatePayload.comune?.nome || consulatePayload.comune?.key?.codice
          ? {
              description: consulatePayload.comune?.nome || '',
              code: consulatePayload.comune?.key?.codice || '',
            }
          : undefined,
      territory:
        consulatePayload.territori?.map((territory) => ({
          code: territory.key.codice,
          description: territory.esonimo,
        })) || [],
    };
  }, [data, error]);

  const navigate = useNavigate();

  const onSubmit = useCallback(() => {
    return;
  }, []);

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonConsulateCrumbs, { name: 'Dettaglio Consolato' }]} />
      {loading || error || !data ? undefined : (
        <FormConsulate
          title="Dettaglio Consolato"
          onOk={onSubmit}
          initialValues={consulate}
          disabled
          onCancel={() => {
            navigate('/sistema/geografiche/estero/consolato');
          }}
        >
          {(formConsulate) => (
            <TerritoryAutoCompleteTable
              disabled
              selectedValues={formConsulate?.values.territory || []}
              handleAdd={(element) => {
                const newTerritories = formConsulate?.values.territory || [];
                const foundElement = newTerritories.find(
                  (territory) => territory.code === element?.code
                );
                if (!foundElement) {
                  formConsulate?.setFieldValue('territory', [...newTerritories, element]);
                }
              }}
              handleRemove={(element) => {
                const oldTerritories = formConsulate?.values.territory || [];
                const newTerritories = oldTerritories.filter((oldTerritory) => {
                  return oldTerritory.code !== element?.code;
                });
                formConsulate?.setFieldValue('territory', newTerritories);
              }}
              error={formConsulate?.touched.territory && Boolean(formConsulate?.errors.territory)}
            />
          )}
        </FormConsulate>
      )}
    </Fragment>
  );
};

ConsulateDetailPage.displayName = 'Consulate Detail page component';

export default ConsulateDetailPage;
